import Crud from '../views/TipoMovimentacao/Crud'
import Entity from '../views/TipoMovimentacao/Add'

let routes = {
    path: '/tipo_movimentacoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_movimentacoes/add',
            name: 'NewTipoMovimentacao',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Movimentações',
                breadcrumb: [
                    {
                        text: 'Tipos de Movimentações',
                        to: '/tipo_movimentacoes',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_movimentacoes/edit/:id?',
            name: 'EditTipoMovimentacao',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Movimentações',
                breadcrumb: [
                    {
                        text: 'Tipos de Movimentações',
                        to: '/tipo_movimentacoes',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_movimentacoes',
            name: 'list-tipo_movimentacoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipo de Movimentações',
                breadcrumb: [
                    {
                        text: 'Tipos de Movimentações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
